const NotesCard = () => {
  return (
    <div className="note-card">
      <h5 className="text-sm font-medium text-foreground mb-3">Please note</h5>
      <ul className="space-y-2 text-sm text-muted-foreground">
        <li className="flex items-start gap-2">
          <span className="text-accent mt-1">•</span>
          <span>You can update or turn off availability anytime</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-accent mt-1">•</span>
          <span>No briefs outside your selected slots</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-accent mt-1">•</span>
          <span>
            Same-day projects require delivery within 3–4 hours (Shoot only) and
            5-6 hours (Shoot + Edit)
          </span>
        </li>
      </ul>
    </div>
  );
};

export default NotesCard;
